import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { WarningTextFieldComponent } from '../../app/components/warning-text-field/warning-text-field.component';

@Component({
  selector: 'reza-landing-page',
  imports: [RouterModule, WarningTextFieldComponent],
  templateUrl: './landing-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LandingPageComponent {}
